import { useEffect, useState } from "react";
import { IReservation } from "@/interfaces/Ipackages";

import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { billingApi } from "@/api/billingApi";

export const Reserved = () => {
  const [reservedList, setReservedList] = useState<IReservation[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReserved = async () => {
      try {
        const { packagesApi } = await import("@/api/packagesApi");
        const response = await packagesApi.getReservation();
        console.log("response", response);
        setReservedList(
          Array.isArray(response.data) ? response.data : [response.data]
        );
      } catch (error) {
        console.error("Error fetching reserved:", error);
        toast.error((error as any).response.data.detail);
      }
    };
    fetchReserved();
  }, []);

  const handlePurchase = async () => {
    try {
      if (reservedList.length === 0) {
        toast.error("No reservations found");
        return;
      }
      if (reservedList.length > 1) {
        toast.error("Multiple reservations found");
        return;
      }

      // Use React Query mutation for creating subscription
      const subscriptionResponse = await billingApi.createSubscription(
        reservedList[0].reservation_id
      );
      console.log("subscriptionResponse", subscriptionResponse);

      // Extract subscription ID from the URL in the response
      const url = subscriptionResponse.data.url;
      const urlParams = new URLSearchParams(url.split("?")[1]);
      const subscriptionId = urlParams.get("subscription_id");

      if (subscriptionId) {
        // Use React Query mutation for creating subscription item
        const subscriptionItemResponse =
          await billingApi.createSubscriptionItem(
            subscriptionId,
            reservedList[0].reservation_id
          );
        console.log("subscriptionItemResponse", subscriptionItemResponse);
        navigate("/post-login");
      } else {
        toast.error("Invalid subscription response");
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
      toast.error("Failed to create subscription. Please try again.");
    }
  };

  const handleDelete = async (reservationId: string) => {
    try {
      const { packagesApi } = await import("@/api/packagesApi");
      await packagesApi.deleteReservation();
      // Remove the deleted reservation from the local state
      setReservedList((prev) =>
        prev.filter(
          (reservation) => reservation.reservation_id !== reservationId
        )
      );
      toast.success("Reservation deleted successfully");
      // Wait for 3 seconds before redirecting
      setTimeout(() => {
        navigate("/select_number");
      }, 3000);
    } catch (error) {
      console.error("Error deleting reservation:", error);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8 text-gray-800">
        Your Reservations
      </h1>
      {reservedList.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg">
          <p className="text-gray-600 text-lg">No active reservations found</p>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reservedList.map((reservation) => (
            <div
              key={reservation.reservation_id}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
            >
              <div className="mb-4">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  {reservation.package.name}
                </h2>
                <div className="space-y-2 text-gray-600">
                  <p className="flex items-center">
                    <span className="font-medium mr-2">Phone:</span>
                    {reservation.phone_number}
                  </p>
                  <p className="flex items-center">
                    <span className="font-medium mr-2">Minutes:</span>
                    {reservation.package.minutes}
                  </p>
                  <p className="flex items-center">
                    <span className="font-medium mr-2">Price:</span>
                    {reservation.package.currency.toUpperCase()}{" "}
                    {reservation.package.price}/
                    {reservation.package.recurring.interval}
                  </p>
                  <p className="flex items-center">
                    <span className="font-medium mr-2">Overage Rate:</span>
                    {reservation.package.currency.toUpperCase()}{" "}
                    {reservation.package.fee_per_overage_minute}
                    /minute
                  </p>
                  <p className="flex items-center">
                    <span className="font-medium mr-2">Expires:</span>
                    {new Date(reservation.expires_at).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <div className="flex justify-between items-center">
                  <span className="inline-block px-3 py-1 text-sm font-medium text-green-700 bg-green-100 rounded-full">
                    Active
                  </span>
                  <button
                    onClick={() => handleDelete(reservation.reservation_id)}
                    className="inline-block px-3 py-1 text-sm font-medium text-red-700 bg-red-100 rounded-full hover:bg-red-200 transition-colors"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="flex justify-center">
        <button
          onClick={() => {
            handlePurchase();
          }}
          className="bg-blue-500 text-white px-4 py-2 rounded-md disabled:bg-blue-300 disabled:cursor-not-allowed"
        >
          Purchase
        </button>
      </div>
    </div>
  );
};
